import axios from 'axios'
import { config } from '@/core/config'
import { IWebTrackCreate, IWebTrackRoute } from '@/core/types'
import { uuid } from 'vue-uuid'
import { IDomainManager } from '@/types/shared'

export class WebTrack {
	private axios
	constructor() {
		const domainManager: IDomainManager[] = Array.from({ length: parseInt(process.env.VUE_APP_DOMAIN_COUNT) }, (_, i) => ({
			domain: process.env[`VUE_APP_DOMAIN_${i}`] || '',
			marketplace: process.env[`VUE_APP_DOMAIN_MARKET_${i}`] || '',
			logo: process.env[`VUE_APP_DOMAIN_IMAGE_${i}`] || '',
			phone: process.env[`VUE_APP_DOMAIN_PHONE_${i}`] || '',
			email: process.env[`VUE_APP_DOMAIN_EMAIL_${i}`] || '',
			title: process.env[`VUE_APP_DOMAIN_TITLE_${i}`] || ''
		}))
		const axiosConfig: Record<string, unknown> = {
			baseURL: config.main.SERVICE_ADMIN,
			withCredentials: false,
			headers: {
				'Content-Type': 'application/json',
				Marketplace: domainManager.find(i => window.location.hostname.includes(i.domain))?.marketplace || domainManager[0]?.marketplace,
				'accept-language': config.main.ACCEPT_LANGUAGE
			}
		}
		this.axios = axios.create(axiosConfig)
	}
	async create(webTrackRoute: IWebTrackRoute) {
		try {
			const data: IWebTrackCreate = {
				functionName: webTrackRoute.functionName,
				moduleName: webTrackRoute.moduleName,
				serviceName: 'bp-cabinet',
				traceId: webTrackRoute.needTraceId ? uuid.v4() : ''
			}
			const options = {
				method: 'post',
				url: '/loggers/api/WebTrack',
				data: data,
				headers: {
					Authorization: `Bearer ${localStorage.getItem('token')}`
				} as Record<string, any>
			}
			if (data.traceId) options.headers['traceId'] = data.traceId
			console.log('%cREQUEST DATA', 'color: #1976D2;font-weight: 600;', '\r\n', options)
			const response = await this.axios(options)
			console.log('%cRESPONSE DATA', 'color: #21BA45;font-weight: 600;', '\r\n', response.data)
		} catch (e: any) {
			const response = e?.response?.data
			if (response) console.log('%cRESPONSE DATA', 'color: #C10015;font-weight: 600;', '\r\n', response)
			else console.log('%cRESPONSE DATA', 'color: #C10015;font-weight: 600;', '\r\n', e)
		}
	}
}
